import {    
    GET_INFO_CHAT
} from "./chat-button.types";
import * as chatButtonService from "../../Services/chat-button.services";

export function getInfoChat() {
    return function (dispatch) {
        try {            
            return chatButtonService.reqInfoChat()
                .then((data) => { 
                    dispatch(
                        {
                            type: GET_INFO_CHAT,
                            payload: data
                        })
                });
        }
        catch (error) {
            return (dispatch) => {
                dispatch({
                    type: GET_INFO_CHAT,
                    payload:-1
                });
            }
        }
    };
}